var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFullWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 66.039,
    viewBox: "0 0 320 66.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_full",
    transform: "translate(2964.049 -1307.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_red",
    transform: "translate(-2803.31 1353.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "red_text",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M671.243,303.45a.817.817,0,0,1-.318.623.722.722,0,0,1-.585.276l-9.846-.018-14.293-.026-2.5,0-.008,4.279a.817.817,0,0,1-.318.623.724.724,0,0,1-.585.277l-6.3-.012a.723.723,0,0,1-.584-.279.817.817,0,0,1-.316-.624l.008-4.279-3.239-.006-.01,5.527a2.62,2.62,0,0,0,.354,1.357,3.19,3.19,0,0,0,.514.655,2.742,2.742,0,0,0,2.009.875l8.815.016a2.729,2.729,0,0,0,2-.868,3.042,3.042,0,0,0,.526-.653,2.68,2.68,0,0,0,.349-1.357l0-2.288,3.6.007h0l21.049.039a2.757,2.757,0,0,0,2.023-.878,2.536,2.536,0,0,0,.516-.653,2.617,2.617,0,0,0,.359-1.356l.01-5.567-3.239-.006Z",
    transform: "translate(-632.354 -293.298)",
    fill: "#c83333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M844.862,303.612a.847.847,0,0,1-.318.633.733.733,0,0,1-.585.267l-9.846-.018-13.6-.025.01-5.22-3.239-.006-.008,4.319a.847.847,0,0,1-.318.633.733.733,0,0,1-.585.266l-9.866-.018-14.808-.027.009-5.22-3.239-.006-.017,9.529a.829.829,0,0,1-.318.634.725.725,0,0,1-.585.276l-1.407,0-.006,3.239,2.664,0a2.739,2.739,0,0,0,2.012-.868,3.035,3.035,0,0,0,.526-.653,2.735,2.735,0,0,0,.349-1.366l0-2.328,9.852.018,16.08.03a2.741,2.741,0,0,0,2.012-.868l.069-.069.02-.02.02-.02.03-.03,0,1.011,4.378.008,21.058.039a2.742,2.742,0,0,0,2.012-.868,3.034,3.034,0,0,0,.526-.653,2.676,2.676,0,0,0,.349-1.356l.01-5.567-3.239-.006Z",
    transform: "translate(-740.064 -293.34)",
    fill: "#c83333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M1064.74,285.72l-.008,4.309a.848.848,0,0,1-.318.633.733.733,0,0,1-.585.266l-9.846-.018-14.333-.026.021-11.2-3.249-.006-.019,10.292a.825.825,0,0,1-.318.633.724.724,0,0,1-.585.276l-2.665-.005.021-11.2-3.239-.006-.02,11.2-1.941,0-.006,3.239,9.1.017a2.742,2.742,0,0,0,2.012-.868.965.965,0,0,1,.079-.07l.03-.04.03-.029,0,1.01,12.7.023,13.478.025a2.74,2.74,0,0,0,2.012-.868,3.036,3.036,0,0,0,.526-.653,2.678,2.678,0,0,0,.349-1.356l.01-5.567Z",
    transform: "translate(-909.219 -279.663)",
    fill: "#c83333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "red_dots",
    transform: "translate(5.691 1.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M651.824,303.012a1.463,1.463,0,0,0,.5.348,1.622,1.622,0,0,0,.634.13,1.552,1.552,0,0,0,.624-.128,1.447,1.447,0,0,0,.516-.346,1.467,1.467,0,0,0,.348-.5,1.626,1.626,0,0,0,.13-.634,1.629,1.629,0,0,0-.474-1.14,1.444,1.444,0,0,0-.514-.348,1.554,1.554,0,0,0-.623-.13,1.636,1.636,0,0,0-.635.127,1.471,1.471,0,0,0-.506.346,1.58,1.58,0,0,0-.348.514,1.55,1.55,0,0,0-.13.624,1.616,1.616,0,0,0,.127.634,1.47,1.47,0,0,0,.346.506",
    transform: "translate(-651.351 -295.129)",
    fill: "#c83333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M748.746,333.1a1.662,1.662,0,0,0-.515-.338,1.621,1.621,0,0,0-.634-.13,1.549,1.549,0,0,0-.624.128,1.506,1.506,0,0,0-.516.336,1.57,1.57,0,0,0-.348.514,1.622,1.622,0,0,0-.13.634,1.551,1.551,0,0,0,.127.624,1.618,1.618,0,0,0,.86.863,1.556,1.556,0,0,0,.624.13,1.627,1.627,0,0,0,.634-.128,1.569,1.569,0,0,0,.516-.346,1.642,1.642,0,0,0,.348-.514,1.672,1.672,0,0,0,.12-.624,1.744,1.744,0,0,0-.118-.634,1.811,1.811,0,0,0-.346-.516",
    transform: "translate(-717.629 -317.805)",
    fill: "#c83333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M732.678,333.074a1.666,1.666,0,0,0-.514-.338,1.621,1.621,0,0,0-.634-.13,1.55,1.55,0,0,0-.624.127,1.511,1.511,0,0,0-.516.336,1.567,1.567,0,0,0-.348.514,1.625,1.625,0,0,0-.13.634,1.551,1.551,0,0,0,.127.624,1.62,1.62,0,0,0,.86.863,1.555,1.555,0,0,0,.624.13,1.629,1.629,0,0,0,.634-.128,1.569,1.569,0,0,0,.515-.346,1.639,1.639,0,0,0,.348-.514,1.675,1.675,0,0,0,.12-.624,1.747,1.747,0,0,0-.118-.634,1.813,1.813,0,0,0-.346-.516",
    transform: "translate(-706.375 -317.785)",
    fill: "#c83333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M794.417,285.894a1.793,1.793,0,0,0,.514.348,1.691,1.691,0,0,0,.634.12,1.673,1.673,0,0,0,.624-.118,1.641,1.641,0,0,0,.516-.346,1.566,1.566,0,0,0,.347-.514,1.623,1.623,0,0,0,0-1.268,1.57,1.57,0,0,0-.346-.516,1.562,1.562,0,0,0-1.138-.468,1.687,1.687,0,0,0-.634.117,1.82,1.82,0,0,0-.516.346,1.575,1.575,0,0,0-.347.515,1.624,1.624,0,0,0,0,1.268,1.566,1.566,0,0,0,.346.516",
    transform: "translate(-751.223 -283.133)",
    fill: "#c83333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M874.438,291.264a1.571,1.571,0,0,0,.514.348,1.626,1.626,0,0,0,1.268,0,1.571,1.571,0,0,0,.516-.345,1.516,1.516,0,0,0,.338-.515,1.555,1.555,0,0,0,.13-.624,1.633,1.633,0,0,0-.127-.634,1.663,1.663,0,0,0-.336-.516,1.816,1.816,0,0,0-.514-.348,1.624,1.624,0,0,0-1.268,0,1.812,1.812,0,0,0-.516.346,1.652,1.652,0,0,0-.338.514,1.621,1.621,0,0,0-.13.634,1.545,1.545,0,0,0,.128.624,1.514,1.514,0,0,0,.336.516",
    transform: "translate(-807.277 -286.894)",
    fill: "#c83333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M968.736,333.509a1.818,1.818,0,0,0-.515-.348,1.667,1.667,0,0,0-.624-.12,1.693,1.693,0,0,0-.634.118,1.617,1.617,0,0,0-.864.86,1.621,1.621,0,0,0-.13.634,1.552,1.552,0,0,0,.127.624,1.642,1.642,0,0,0,.346.516,1.625,1.625,0,0,0,1.148.478,1.551,1.551,0,0,0,.624-.128,1.569,1.569,0,0,0,.516-.346,1.449,1.449,0,0,0,.348-.514,1.561,1.561,0,0,0,.13-.624,1.627,1.627,0,0,0-.128-.634,1.582,1.582,0,0,0-.346-.516",
    transform: "translate(-871.711 -318.089)",
    fill: "#c83333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M1138.009,333.821a1.814,1.814,0,0,0-.515-.348,1.662,1.662,0,0,0-.624-.12,1.691,1.691,0,0,0-.634.117,1.621,1.621,0,0,0-.863.86,1.626,1.626,0,0,0-.13.634,1.555,1.555,0,0,0,.128.624,1.638,1.638,0,0,0,.346.516,1.627,1.627,0,0,0,1.148.478,1.56,1.56,0,0,0,.624-.128,1.579,1.579,0,0,0,.516-.346,1.449,1.449,0,0,0,.348-.514,1.559,1.559,0,0,0,.13-.624,1.623,1.623,0,0,0-.128-.634,1.578,1.578,0,0,0-.346-.516",
    transform: "translate(-990.27 -318.307)",
    fill: "#c83333"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "logo_white",
    transform: "translate(-2964.049 1307.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M124.093,155.362c0,8.367-5.316,14.175-12.207,14.175a9.555,9.555,0,0,1-7.678-3.544v2.9H95.84V131h8.367v13.88a9.411,9.411,0,0,1,7.728-3.692c6.743,0,12.157,5.759,12.157,14.176m-8.466,0c0-3.741-2.461-6.2-5.709-6.2s-5.71,2.461-5.71,6.2c0,3.79,2.461,6.2,5.71,6.2,3.2,0,5.709-2.412,5.709-6.2",
    transform: "translate(-95.84 -129.029)",
    fill: "#f2eff2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M231.533,165.645l-.049,27.071h-8.368v-2.9a9.384,9.384,0,0,1-7.629,3.544c-6.891,0-12.207-5.808-12.207-14.175,0-8.417,5.414-14.175,12.158-14.175a9.411,9.411,0,0,1,7.728,3.692v-3.052Zm-8.367,13.536c0-3.741-2.461-6.2-5.71-6.2s-5.709,2.461-5.709,6.2c0,3.79,2.51,6.2,5.709,6.2,3.249,0,5.71-2.412,5.71-6.2",
    transform: "translate(-171.091 -152.848)",
    fill: "#f2eff2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 8.367,
    height: 37.9,
    transform: "translate(65.362 1.969)",
    fill: "#f2eff2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M384.971,165.645l-.049,27.071h-8.368v-2.9a9.383,9.383,0,0,1-7.629,3.544c-6.891,0-12.207-5.808-12.207-14.175,0-8.417,5.414-14.175,12.158-14.175A9.411,9.411,0,0,1,376.6,168.7v-3.052ZM376.6,179.18c0-3.741-2.461-6.2-5.71-6.2s-5.709,2.461-5.709,6.2c0,3.79,2.51,6.2,5.709,6.2,3.249,0,5.71-2.412,5.71-6.2",
    transform: "translate(-278.559 -152.848)",
    fill: "#f2eff2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M544.98,155.362c0,8.367-5.316,14.175-12.207,14.175a9.554,9.554,0,0,1-7.678-3.544v2.9h-8.368V131h8.368v13.88a9.411,9.411,0,0,1,7.728-3.692c6.743,0,12.157,5.759,12.157,14.176m-8.466,0c0-3.741-2.461-6.2-5.709-6.2s-5.71,2.461-5.71,6.2c0,3.79,2.461,6.2,5.71,6.2,3.2,0,5.709-2.412,5.709-6.2",
    transform: "translate(-390.63 -129.029)",
    fill: "#f2eff2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M652.42,180.953H632.682c.394,4.184,3.052,5.956,5.956,5.956a4.694,4.694,0,0,0,4.774-3.052h8.613c-1.87,6.694-7.531,9.5-13.388,9.5-8.663,0-14.471-6.153-14.471-14.176s5.857-14.175,14.274-14.175c8.958,0,14.815,7.039,13.979,15.948m-19.491-5.07h10.779a5.128,5.128,0,0,0-5.316-4.43c-3,0-4.774,1.821-5.464,4.43",
    transform: "translate(-465.881 -152.848)",
    fill: "#f2eff2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M757.926,175.785v16.932h-8.368V177.655c0-2.953-.886-4.676-4.282-4.676-3.3,0-4.971,1.624-4.971,5.365v14.372h-8.368V165.646H740.3V168.7a9.529,9.529,0,0,1,7.826-3.691c6.1,0,9.795,4.184,9.795,10.779",
    transform: "translate(-541.363 -152.848)",
    fill: "#f2eff2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M855.348,186.337v7.875H831.821v-7.875l12.059-11.321H832.559V167.14h22.346v7.876l-12.059,11.321Z",
    transform: "translate(-611.322 -154.343)",
    fill: "#f2eff2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M931.494,129.2a4.774,4.774,0,0,1-5.07,4.824,4.806,4.806,0,1,1,0-9.6,4.764,4.764,0,0,1,5.07,4.774m-9.254,8.023h8.367v27.071H922.24Z",
    transform: "translate(-674.031 -124.426)",
    fill: "#f2eff2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M994.655,175.785v16.932h-8.368V177.655c0-2.953-.886-4.676-4.282-4.676-3.3,0-4.971,1.624-4.971,5.365v14.372h-8.367V165.646h8.367V168.7a9.528,9.528,0,0,1,7.826-3.691c6.1,0,9.8,4.184,9.8,10.779",
    transform: "translate(-707.169 -152.848)",
    fill: "#f2eff2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M1097.623,180.953h-19.737c.394,4.184,3.052,5.956,5.956,5.956a4.694,4.694,0,0,0,4.774-3.052h8.614c-1.87,6.694-7.531,9.5-13.388,9.5-8.663,0-14.471-6.153-14.471-14.176s5.857-14.175,14.274-14.175c8.958,0,14.816,7.039,13.979,15.948m-19.491-5.07h10.779a5.128,5.128,0,0,0-5.316-4.43c-3,0-4.775,1.821-5.464,4.43",
    transform: "translate(-777.702 -152.848)",
    fill: "#f2eff2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo_yellow",
    transform: "translate(-2957.722 1358.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M121.152,295.87a1.3,1.3,0,0,1,.8-.59q.424-.071,1.226.59.329.377.873.9t1.132,1.156q.589.637,1.25,1.344t1.274,1.415a1.663,1.663,0,0,1,.472.9,1.327,1.327,0,0,1-.283,1.038l-3.679,5.8a1.7,1.7,0,0,1-.5.542.419.419,0,0,1-.378.047,1.188,1.188,0,0,1-.354-.259,3.6,3.6,0,0,0-.377-.33l-5.425-4.434a.825.825,0,0,1-.141-.967,7.778,7.778,0,0,1,.613-1.2q.9-1.652,1.745-3.184a26.1,26.1,0,0,1,1.745-2.759",
    transform: "translate(-116.957 -295.274)",
    fill: "#e1b03d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M551.523,295.87a1.3,1.3,0,0,1,.8-.59q.424-.071,1.226.59.329.377.873.9t1.132,1.156q.589.637,1.25,1.344t1.274,1.415a1.663,1.663,0,0,1,.472.9,1.327,1.327,0,0,1-.283,1.038l-3.679,5.8a1.7,1.7,0,0,1-.5.542.419.419,0,0,1-.377.047,1.187,1.187,0,0,1-.354-.259,3.6,3.6,0,0,0-.377-.33l-5.425-4.434a.825.825,0,0,1-.141-.967,7.778,7.778,0,0,1,.613-1.2q.9-1.652,1.745-3.184a26.094,26.094,0,0,1,1.745-2.759",
    transform: "translate(-418.389 -295.274)",
    fill: "#e1b03d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFullWhite);
export default __webpack_public_path__ + "static/media/logo_full_white.b77b6ba5b9df6a33a603b5654b995d1b.svg";
export { ForwardRef as ReactComponent };